import type { AppThunk } from 'typesafe-actions';
import { createAsyncAction } from 'typesafe-actions';

import type { SuggestionsErrors, SuggestionsItem } from 'Suggestions-Types';

import type { FetchOption } from './apis';
import { fetch } from './apis';

// XXX: Kindly update payloads to your own async implementation
export const fetchSuggestionsAsync = createAsyncAction(
  'FETCH_SUGGESTIONS_REQUEST',
  'FETCH_SUGGESTIONS_SUCCESS',
  'FETCH_SUGGESTIONS_FAILURE',
)<undefined, SuggestionsItem[], SuggestionsErrors[]>();

export const fetchSuggestions =
  (text: string, options?: FetchOption): AppThunk =>
  async (dispatch, getState, { apiClient }) => {
    try {
      dispatch(fetchSuggestionsAsync.request());
      const suggestions = await fetch(text, { limit: 5, ...options }, apiClient);
      dispatch(fetchSuggestionsAsync.success(suggestions));
    } catch (error) {
      //@ts-ignore
      dispatch(fetchSuggestionsAsync.failure(error));
    }
  };
